// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconRusd } from "../../../icons/mono/build/icon-rusd.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const RusdIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconRusd.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  RusdIcon.displayName = 'RusdIcon';
}

export default RusdIcon;